const COOKIE_NAME = 'cookies_private';
const EXPIRES = 365;

const needNotice = () => {
    return `
        <div class="cookies__block cookie-private--js">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="cookies__body">
                        <div class="cookies__header">
                            <div class="cookies__title">Наш веб-сайт использует Cookies</div>
                            <div class="cookies__button">
                                <a class="btn btn-primary cookie-private__btn--js" href="#">Согласен</a>
                            </div>
                        </div>
                        <div class="cookies__content">
                            <div class="cookies__text">
                                <p>
                                    Наш веб-сайт использует Cookies для улучшения работоспособности веб-сайта, анализа использования данных сайта.
                                    Продолжая работу на веб-сайте, Вы даете свое согласие на обработку своих персональных данных в соответствии
                                    с <a href="/policy/">Политикой сайта</a>  в отношении персональных данных, опубликованной на нашем
                                    веб-сайте. Вы можете запретить обработку Cookies в настройках браузера.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
}

if (!Cookies.get(COOKIE_NAME)) {
    document.querySelector('body').insertAdjacentHTML('beforeend', needNotice());

    const BOTTOM_NOTICE = document.querySelector('.cookie-private--js');
    const AGREE_BTN = document.querySelector('.cookie-private__btn--js');

    setTimeout(() => BOTTOM_NOTICE.classList.add('show-notice'), 4000);

    AGREE_BTN.addEventListener('click', (e) => {
        e.preventDefault();
        setCookie();
    });

    function setCookie() {
        document.querySelector('.cookie-private--js').classList.remove('show-notice');

        setTimeout(() => document.querySelector('.cookie-private--js').remove(), 1000);

        Cookies.set(COOKIE_NAME, true, {expires: 31});
    }
} else {
    Cookies.set(COOKIE_NAME, true, {expires: 31});
}